{
    "key": "Price",
    "activeKeys": [
        {
            "key": "Discount",
            "type": "number",
            "width": "55px",
            "step": true,
            "stepValue": "0.01",
            "nullValue": "0.00"
        }
    ],
    "mappedKeys": [
        "Id",
        "Name",
        "Currency",
        "Discount",
		"DairyDiscount",
        "TotalDiscount",
        "CostPrice",
        "NetPrice",
		"Margin",
        "SalesPrice",
        "SalesPriceUnitOfMeasure",
		"CostPriceForSalesUnit"
    ]
}
